import * as React from "react";
import classNames from "classnames";
import { useHistory } from "react-router-dom";

import Button from "../shared/Button";
import Hero from "../shared/Hero";
import { useCreationDispatch } from "../creationFlowHooks";
import { resetCreation } from "../creationFlowActions";
import Api from "../api";


interface Props {
  children: string;
  className: string;
}

export const AppLayout: React.FC<Props> = ({ children, className }: Props) => {
  return (
    <div
      className={classNames(
        "flex flex-col flex-1 overflow-hidden relative",
        className
      )}
    >
      {children[0]}
      <div className="pb-3 my-3 overflow-y-auto flex-1">
        <div className="flex flex-1 flex-col items-center mx-8">
          {children[1]}
        </div>
        <div className="flex flex-col justify-end pt-5">
          {children[2]}
        </div>
        <div className="flex flex-col justify-end pt-5 pb-5">
          {children[3]}
        </div>
      </div>
    </div>
  );
};

const Splash: React.FC = () => {
  const history = useHistory();
  const dispatch = useCreationDispatch();

  React.useEffect(() => {
    Api.clearSession();
    dispatch(resetCreation());
  }, []);

  const start = () => {
    history.push("/customer-details");
  };

  return (
    <AppLayout className="bg-bgBody">
      <Hero role="SPLASH" size="large"/>
      
     <div className="mt-16">
          <h1 className="text-5xl font-bold text-center">
            Goalie
          </h1>
          <h1 className="text-5xl font-bold text-center">
            Challenge
          </h1>
      </div>
      <div className="flex flex-grow pb-3 mt-3 w-full rounded-lg justify-center">
          <h1 className="font-text text-2xl text-center pb-7">
            How many goals<br />can you save?
          </h1>
      </div>

      <div className="flex items-end mx-4 pb-5">
        <Button theme="primary" className="" onClick={start}>
          START
        </Button>
      </div>
    </AppLayout>
  );
};

export default Splash;
